import React from 'react';
import { Tooltip } from '@nackle/paper';
import './help.less';
export default class Help extends React.Component {
  render() {
    const {
      text
    } = this.props;
    return /*#__PURE__*/React.createElement(Tooltip, {
      className: "help-tooltip",
      title: text,
      color: "geekblue"
    }, /*#__PURE__*/React.createElement("a", {
      href: "#help"
    }, /*#__PURE__*/React.createElement("span", {
      className: "help-icon"
    }, "?")));
  }
}
//# sourceMappingURL=help.js.map